import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { NAVIGATION_TABS_FOR_PAGES } from "../../constants/constants-container";
import "./ActivityNavigation.css";

const ActivityNavigation = ({ type, scrollTargets }) => {
  const [activeTab, setActiveTab] = useState("All");

  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);

    Object.entries(scrollTargets).forEach(([key, ref]) => {
      if (ref.current) {
        ref.current.style.display = key === tabKey ? "block" : "none";
      }
    });
  };

  const handleShowAll = () => {
    setActiveTab("All");

    Object.values(scrollTargets).forEach((ref) => {
      if (ref.current) {
        ref.current.style.display = "block";
      }
    });
  };

  if (!NAVIGATION_TABS_FOR_PAGES[type]) return null;
  const tabs = NAVIGATION_TABS_FOR_PAGES[type] || [];

  return (
    <div className="jira-navigation-container">
      <span>Show:</span>
      <div className="jira-button-group">
        <Button
          className={`jira-button ${activeTab === "All" ? "active" : ""}`}
          onClick={handleShowAll}
        >
          All
        </Button>

        {tabs
          .filter((tab) => {
            const [key] = Object.entries(tab)[0];
            return scrollTargets[key]?.current;
          })
          .map((tab) => {
            const [key, value] = Object.entries(tab)[0];
            return (
              <Button
                key={key}
                className={`jira-button ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {value}
              </Button>
            );
          })}
      </div>
    </div>
  );
};

export default ActivityNavigation;
